'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Group = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _swiper = require('swiper');

var _swiperReact = require('swiper/react/swiper-react');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Group = function Group(_ref) {
  var inline = _ref.inline,
      className = _ref.className,
      children = _ref.children,
      onClick = _ref.onClick,
      props = (0, _objectWithoutProperties3.default)(_ref, ['inline', 'className', 'children', 'onClick']);

  return _react2.default.createElement('ul', (0, _extends3.default)({
    className: (0, _classnames2.default)('pill-Group', className, {
      'pill-Group-wrap': !inline,
      'pill-Group-inline util-HideScrollbar': inline
    })
  }, props), inline ? _react2.default.createElement(_swiperReact.Swiper, {
    className: 'car-Container car-Container-free-mode',
    modules: [_swiper.FreeMode],
    freeMode: { enabled: true, sticky: false },
    slidesPerView: 'auto'
  }, children.map(function (pill, index) {
    return _react2.default.createElement(_swiperReact.SwiperSlide, { key: index }, _react2.default.createElement('li', { className: 'pill-Group_Item' }, pill));
  })) : _react2.default.createElement(_react.Fragment, null, children.map(function (pill, index) {
    return _react2.default.createElement('li', { className: 'pill-Group_Item', key: index }, pill);
  })));
};

exports.Group = Group;
Group.defaultProps = {
  inline: false,
  className: undefined,
  onClick: function onClick() {
    return null;
  }
};

Group.propTypes = {
  inline: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  children: _propTypes2.default.node.isRequired
};